import { Modal } from "antd";
import React from "react";

import styled from "styled-components";
import SearchPage from "./SearchPage/SearchPage";

function ModalCommercial(props) {
  return (
    <ModalCustom
      open={props.open}
      onCancel={props.onCancel}
      footer={null}
      width={"fit-content"}
    >
      <div className="container container-wrapper">
        <SearchPage
          isCommercial={true}
          activeTabId={props.activeTabId}
          projectId={props.projectId}
        />
      </div>
    </ModalCustom>
  );
}

export default ModalCommercial;

const ModalCustom = styled(Modal)`
  .ant-modal-header {
    background-color: rgb(25, 26, 31);
  }

  .ant-modal-title {
    color: #fff;
  }

  .ant-modal-content {
    background-color: rgb(25, 26, 31);
  }

  .ant-modal-body {
    margin-top: 20px;
  }

  .ant-select-selection-item {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-inline-end: 0;
  }
`;
